import DashboardCard from "../../components/common/DashboardCard"
import DashboardLayout from "../../components/Layout/DashboardLayout"

const AdminDashboard = () => {
  return (
    <DashboardLayout pageTitle="Admin Dashboard" mainClass="p-6">
      <div className="bg-white p-6 rounded shadow-md  mx-auto">
        <DashboardCard />
      </div>
    </DashboardLayout>
  )
}

export default AdminDashboard;